import { TUTORING_LEAD_SOURCES } from "@seneca/tutoring-service-consts";

import { linkToParentDashboard } from "../../links";

export const OneToOneTutoringSourceParamKey = "oneToOneTutoringSource";

export function linkToTutoringPage(source?: TUTORING_LEAD_SOURCES) {
  const queryParams = source
    ? `?${OneToOneTutoringSourceParamKey}=${source}`
    : "";

  return `${linkToParentDashboard()}/tutoring${queryParams}`;
}
